import { http } from "@/api/http";

const path = "/system/onGetCheckImage";

export interface LoginCaptchaResponse {
  image_id: string;
  image_base64: string;
  captcha_text: string;
}

export function imageBase64ToDataUrl(imageBase64: string): string {
  const t = imageBase64.trim();
  return t.startsWith("data:") ? t : `data:image/png;base64,${t}`;
}

export async function fetchLoginCaptcha(options?: {
  signal?: AbortSignal;
}): Promise<LoginCaptchaResponse> {
  const p = await http.post<LoginCaptchaResponse>(path, undefined, {
    signal: options?.signal,
  });
  return {
    image_id: p.image_id,
    image_base64: p.image_base64,
    captcha_text: p.captcha_text,
  };
}
